import { useState } from 'react';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { hide } from '../../services/reducers/popupSlice';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import { AppDispatch } from '../../services/store';

interface InventoryConvertModalProps {
  product: any;
  onSuccess: (updatedProduct: any) => void;
}

// "تبدیل رول به کارتن" modal. رولی -> قوطی only (no reverse direction) — the
// backend (AdminInventoryController.convertRollToBox) converts N کارتن رولی
// into as many whole کارتن قوطی as the freed items allow, carrying any
// leftover forward in خرده تبدیل until it accumulates enough for another
// کارتن قوطی.
const InventoryConvertModal = ({ product, onSuccess }: InventoryConvertModalProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [rollCount, setRollCount] = useState<string>('');

  const close = () => dispatch(hide());

  const numericRollCount = Number(rollCount);
  const previewItemsFreed = numericRollCount > 0 && product.itemsPerRoll
    ? numericRollCount * product.itemsPerRoll
    : 0;
  const previewPool = previewItemsFreed + (product.remains || 0);
  const previewWholeBoxes = product.itemsPerBox ? Math.floor(previewPool / product.itemsPerBox) : 0;
  const previewRemains = product.itemsPerBox ? previewPool % product.itemsPerBox : previewPool;

  const submit = async () => {
    if (!numericRollCount || numericRollCount <= 0) {
      Swal.fire({
        title: 'خطا',
        text: 'تعداد کارتن رولی را به درستی وارد کنید',
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
      return;
    }
    if (numericRollCount > (product.rollCount || 0)) {
      Swal.fire({
        title: 'خطا',
        text: 'تعداد کارتن رولی بیشتر از موجودی است',
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
      return;
    }

    dispatch(setLoading(true));
    const res = await restApi(endpoints.product.inventory + 'convert/' + product.id, true).post({
      rollCount: numericRollCount
    });
    dispatch(setLoading(false));

    if (res.code === 200) {
      const updated = res.data;
      onSuccess(updated);
      close();
      Swal.fire({
        title: 'موفق',
        html: `تبدیل رول به کارتن برای «${product.title}» انجام شد<br/>` +
          `تعداد کارتن رولی باقیمانده: ${updated.rollCount} × ${updated.itemsPerRoll || '—'}<br/>` +
          `تعداد کارتن قوطی جدید: ${updated.boxCount} × ${updated.itemsPerBox || '—'}<br/>` +
          `خرده تبدیل: ${updated.remains}<br/>` +
          `کل موجودی: ${updated.inventory}`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم'
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data || 'خطا در تبدیل رول به کارتن',
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }
  };

  return (
    <div className="modalContainer" style={{ width: 440, height: 'auto', position: 'static', margin: 0 }}>
      <div className="modalHeading">
        <h2>تبدیل رول به کارتن</h2>
        <i className="modalExit clickable" onClick={close}></i>
      </div>

      <div className="modalForm" style={{ flexDirection: 'column' }}>
        <div style={{ width: '100%' }} className="modalInfoLine">
          {product.title} ({product.sku})
        </div>

        <div style={{ width: '100%' }} className="modalInfoLine">
          تعداد کارتن رولی فعلی: {product.rollCount || 0} × {product.itemsPerRoll || '—'} — خرده تبدیل فعلی: {product.remains || 0}
        </div>

        <div style={{ width: '100%' }}>
          <label>تعداد کارتن رولی برای تبدیل</label>
          <input
            type="number"
            min="1"
            max={product.rollCount || undefined}
            value={rollCount}
            onChange={(e) => setRollCount(e.target.value)}
            autoFocus
          />
        </div>

        {numericRollCount > 0 && (
          <div style={{ width: '100%' }} className="modalPreviewLine">
            نتیجه: {previewWholeBoxes}+ تعداد کارتن قوطی، خرده تبدیل جدید: {previewRemains}
          </div>
        )}
      </div>

      <div className="modalBtns">
        <span className="cancel clickable" onClick={close}>انصراف</span>
        <span className="submit clickable" onClick={submit}>ثبت</span>
      </div>
    </div>
  );
};

export default InventoryConvertModal;
